import clsx from 'clsx';

import type { FC, HTMLAttributes } from 'react';

import s from './GroupHeader.module.css';

type GroupHeaderProps = HTMLAttributes<HTMLDivElement>;

const GroupHeader: FC<GroupHeaderProps> = ({ className, ...props }) => (
  <div className={clsx(s.header, className)} {...props} />
);

export { GroupHeader };
